import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const DeletePatientModal = ({ open, onClose, onConfirm, patient }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Delete Patient</DialogTitle>
            <DialogContent>
                {patient ? (
                    <DialogContentText>
                        Are you sure you want to delete patient <strong>{patient?.name} {patient?.lastname}</strong>?
                    </DialogContentText>
                ) : (
                    <DialogContentText>
                        No patient selected for deletion.
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                {patient && (
                    <Button onClick={onConfirm} variant="contained" color="secondary">
                        Delete
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default DeletePatientModal;
